import React from 'react';
import {useDispatch, useSelector } from 'react-redux';
import './PollOption.scss';
import { reportEvent } from '../../../store/reducers/gaReducer';
import Checkmark from '../../../assets/images/graphics/icn_checkmark.png';
import Button from '../../Common/Button/Button';

import { getImageFilepath, hexToRgb } from '../../../models/Utils';

import { useMediaQuery } from 'react-responsive';
import { ADAARIARoles } from '../../../models/ADA';


const PollOption = props => {
  const dispatch = useDispatch();
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const handlePollClicked = e => {
    if (props.choice < 0) {
      props.onClick(props.dataKey);
      dispatch(reportEvent({ category:"POLL_ANSWERED - " + props.pollQuestion, action:props.text}));
    }
  };

  const background = props.background;
  const outerStyle = {
    width: props.width,
    transitionDelay: props.index * 0.2 + 's',
  };
  let innerStyle = {
    backgroundImage: background.Image
      ? 'url("' + mediaPath + getImageFilepath(background.Image) + '")'
      : '',
    width: props.tally ? 'calc(100% - 140px)' : '100%',
  };
  let buttonSize = isPortrait === false ? 'btn--medium' : 'btn--small';
  let button = (
    <Button
      children={props.buttonText}
      buttonStyle="btn--outline"
      buttonSize={buttonSize}
      buttonColor="transparent"
      onClick={handlePollClicked}
      label={'Vote for' + props.text}
    />
  );

  return (
    <div className="vote-outer" style={outerStyle}>
      <div className="vote-inner" style={innerStyle}>
        <div
          className="overlay"
          style={{
            position: 'absolute',
            width:'100%',
            height:'100%',
            backgroundColor: background.Overlay,
            opacity: background.Opacity,
          }}>
        </div>
        <div className="vote-content">
          <div className="vote-text" role={ADAARIARoles.Heading} aria-level="3">{props.text}</div>
          {props.choice < 0 ? <div className="button-holder">{button}</div> : null}
          {props.choice === props.dataKey ? (
            <div className="checkmark-holder"  role={ADAARIARoles.Region}>
              <img className="checkmark-image" src={Checkmark} alt={"Selected Poll:" + props.text} />
              <div className="checkmark-text" aria-hidden>Your choice</div>
            </div>
          ) : null}
        </div>
      </div>
      {props.tally ? (
        <div className="vote-tally-outer">
          <div className="vote-tally-inner"  role={ADAARIARoles.Region}>
            <div className="vote-percent">{props.tally}</div>
            <div className="vote-description">Chose this</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PollOption;
